<div class="tf-notification" [style.display]="state.value === 'inactive' ? 'none' : ''">

    <div class="tf-notification-highlight-ctrn">
    </div>

    <div class="tf-notification-icon-ctnr">
        <div class="tf-notification-icon"></div>
    </div>

    <div class="tf-notification-body-ctrn">

        <div>
            <div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title" class="title">
                {{ title }}
            </div>
            <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite"
                 [class]="options.messageClass" [innerHTML]="message">
            </div>
            <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite" class="message"
                 [class]="options.messageClass" [attr.aria-label]="message">
                {{ message }}
            </div>
        </div>

        <div class="tf-notification-close-ctrn">
            <div *ngIf="options.closeButton" (click)="remove()" class="close-icon"></div>
        </div>

    </div>

</div>

<div *ngIf="options.progressBar">
    <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
